import { ref } from '@vue/composition-api'

import store from '@/store/'
import { STORE_MODULE_NAME } from "./wrappedReportStoreModule";

export default function useWrappedReport() {

    // Table Handlers
  const tableColumns = ref([
    {
      key: 'name',
      label: 'название',
    },
    {
      key: 'actions',
      actions: [
        {
          key: "download",
          label: 'скачать',
          icon: 'PlayIcon',
          action: (item) => {
            store.commit(`${STORE_MODULE_NAME}/SET_IS_DOWNLOAD_REPORT_MODAL_ACTIVE`, true)
            store.commit(`${STORE_MODULE_NAME}/SET_DOWNLOAD_REPORT_MODAL_DATA`, item)
          }
        }
      ]
    }
  ])

  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`
  const downloadDataUrl = `${STORE_MODULE_NAME}/generate_download`

  return {

    fetchDataUrl,
    downloadDataUrl,

    tableColumns,
  }
}
